import * as React from 'react';

import { FormBox } from "../FormBox";
import {
FormCheckboxBox,
FormCheckboxDot,
FormCheckboxLabel,
FormCheckboxWrapper } from "./FormCheckbox.styles";



















export const FormCheckbox = ({
  input: {
    name = 'checkbox',
    value = true,
    onChange = () => void 0,
    onFocus = () => void 0,
    onBlur = () => void 0,
    onClick = () => void 0 } =
  {},
  error = '',
  autoHeight = true,
  noBorder = true,
  children }) =>
{
  return /*#__PURE__*/(
    React.createElement(FormBox, { autoHeight: autoHeight, noBorder: noBorder, inputName: name, error: error }, /*#__PURE__*/
    React.createElement(FormCheckboxWrapper, { autoHeight: autoHeight }, /*#__PURE__*/
    React.createElement(FormCheckboxBox, { active: value }, /*#__PURE__*/
    React.createElement(FormCheckboxDot, { active: value }), /*#__PURE__*/
    React.createElement(FormCheckboxLabel, null,
    children, /*#__PURE__*/
    React.createElement("input", {
      type: "checkbox",
      name: name,
      checked: value,
      autoComplete: "off",
      onChange: onChange,
      onFocus: onFocus,
      onBlur: onBlur,
      onClick: onClick }))))));






};